import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';
import { spin } from '../../utils/style';

interface SpinnerProps {
	width?: string;
	height?: string;
	borderWidth?: string;
	color?: string;
}

export const Spinner = styled('div')`
	position: relative;
	display: inline-block;
	width: ${(props: SpinnerProps) => props.width ? props.width : '35px'};
	height: ${(props: SpinnerProps) => props.height ? props.height : '35px'};
	color: ${(props: SpinnerProps) => props.color ? props.color : StyleColor.Blue600};
	border-radius: 50%;
	animation: ${spin};

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 50%;
	}

	&::before {
		border: ${(props: SpinnerProps) => props.borderWidth ? props.borderWidth : '4px'} solid currentColor;
		opacity: 0.2;
	}

	&::after {
		border: ${(props: SpinnerProps) => props.borderWidth ? props.borderWidth : '4px'} solid currentColor;
		border-top-color: transparent;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Spinner/styles.ts